import React from "react";
import { useTranslation } from "react-i18next";
import { cardColors } from "../../constants/colors";
import { useSettings } from "../../context/SettingsContext";
import { GridItem } from "../../types/GridItem";

type AccessibilityClickableCardProps = {
  item: GridItem;
  isSelected: boolean;
  onClick: (title: string) => void;
  onKeyDown: (e: React.KeyboardEvent, title: string) => void;
  setButtonRef: (id: string, el: HTMLButtonElement | null) => void;
  tooltip: JSX.Element;
};

const AccessibilityClickableCard: React.FC<AccessibilityClickableCardProps> =
  React.memo(
    ({
      item,
      isSelected,
      onClick,
      onKeyDown,
      setButtonRef,
      tooltip: TooltipComponent,
    }) => {
      const { oversizeWidget } = useSettings();
      const { t } = useTranslation();

      return (
        <button
          tabIndex={0}
          ref={(el) => setButtonRef(item.title, el)}
          style={{ height: oversizeWidget ? "28vh" : "" }}
          className={`w-full sm:w-[40%] h-28 px-8 cursor-pointer relative flex flex-col accessibility-card items-center justify-center rounded-[20.52px] py-4 md:hover:bg-blue-200 hover:shadow-lg ${
            isSelected
              ? `${cardColors.selected.background}  border-2 ${cardColors.selected.border}`
              : `${cardColors.default.background} text-gray-700`
          }`}
          onClick={() => onClick(item.title)}
          onKeyDown={(e) => onKeyDown(e, item.title)}
        >
          {TooltipComponent}

          <div
            className="w-9 h-9 p-1 flex items-center justify-center mb-2 rounded-full"
            style={{
              height: oversizeWidget ? "55px" : "",
              width: oversizeWidget ? "55px" : "",
            }}
          >
            {item.icon}
          </div>
          <p
            className={`text-sm text-gray-700 pb-3 text-center ${
              oversizeWidget ? "text-2xl font-bold" : ""
            }`}
            style={{
              fontSize: oversizeWidget ? "1.375rem" : "",
              color: isSelected ? "white" : oversizeWidget ? "black" : "",
              fontWeight: oversizeWidget ? "600" : "normal",
              wordBreak: "break-word",
              lineHeight: "1.5",
            }}
          >
            {t(item.label)}
          </p>
        </button>
      );
    }
  );

AccessibilityClickableCard.displayName = "AccessibilityClickableCard";

export default AccessibilityClickableCard;
